// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8f-3";
export var contentContainer = "_8f-0";
export var editorContainer = "_8f-1";
export var quillInputForm = "_8f-2";
export var zoneDivider = "_8f-4";